import { FiFileText, FiShield, FiUser, FiUsers } from 'react-icons/fi';
import { KycDocumentType } from '../../api/kyc/types';

export const KYC_MAX_FILE_SIZE = 10 * 1024 * 1024;
export const KYC_UPLOAD_ACCEPT = '.pdf,.jpg,.jpeg,.png,.gif,.bmp,.webp';
const extensions = /\.(pdf|jpe?g|png|gif|bmp|webp)$/i;
const mimeTypes = [
    'application/pdf',
    'image/jpeg',
    'image/png',
    'image/gif',
    'image/bmp',
    'image/x-ms-bmp',
    'image/webp',
];
export const getKycFileError = (file: File): 'emptyFile' | 'largeFile' | 'invalidFile' | null => {
    if (file.size === 0) return 'emptyFile';
    if (file.size > KYC_MAX_FILE_SIZE) return 'largeFile';
    if (file.type ? !mimeTypes.includes(file.type) : !extensions.test(file.name)) return 'invalidFile';
    return null;
};

export const isKycDocumentType = (type?: string): type is KycDocumentType =>
    type === 'company_charter' || type === 'annual_report' || type === 'ubo';

export const getKycIcon = (type?: string) => {
    if (type === 'kbo') return FiShield;
    if (type === 'admin_id') return FiUser;
    if (type === 'beneficiaries' || type === 'ubo') return FiUsers;
    return FiFileText;
};
